import { Box, Button, Stack, styled } from '@mui/material';

/* 그리드 버튼 스타일 */
export const ContentBox = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 4,
  background: theme.palette.background.default,
}));

export const ContentBoxButtons = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: theme.spacing(0.5),
}));

export const ContentButton = styled(Button)(({ theme }) => ({
  background: theme.palette.background.default,
  border: `1px solid ${theme.palette.text.secondary}`,
  color: theme.palette.text.primary,
  height: 30,
  '&:hover': {
    background: theme.palette.text.secondary,
    color: theme.palette.common.white,
  },
}));

export const ContentButtonText = styled(Button)(({ theme }) => ({
  background: theme.palette.background.default,
  border: `none`,
  color: theme.palette.text.secondary,
  height: 30,
  '&:hover': {
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  fontSize: 12,
}));

export const ContentButtonDelete = styled(Button)(({ theme }) => ({
  background: theme.palette.background.default,
  border: `1px solid ${theme.palette.error.main}`,
  color: theme.palette.text.secondary,
  height: 30,
  '&:hover': {
    background: theme.palette.error.main,
    color: theme.palette.common.white,
  },
}));

export const ContentButtonCreate = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.common.white,
  height: 30,
  '&:hover': {
    background: theme.palette.primary.darker,
  },
}));

export const ContentButtonAction = styled(Button)(({ theme }) => ({
  background: theme.palette.success.main,
  border: `1px solid ${theme.palette.success.main}`,
  color: theme.palette.common.white,
  height: 30,
  '&:hover': {
    background: theme.palette.success.darker,
  },
}));

export const ContentYelloButton = styled(Button)(({ theme }) => ({
  background: theme.palette.warning.main,
  border: `1px solid ${theme.palette.warning.main}`,
  color: theme.palette.common.white,
  height: 30,
  '&:hover': {
    background: theme.palette.warning.darker,
  },
}));

// 그리드 셀에서 위/아래 정렬할 때 사용하는 Box
export const RowBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
}));
